export default "__VITE_ASSET__6a68517e__"